import { FONT_WEIGHTS } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/constants'
import { FontWeightType } from 'components/VisualStudioPlayground/VisualEditor/Types'
import FontFaceObserver from 'fontfaceobserver'
import { makeAutoObservable } from 'mobx'
import { Font } from 'types'
import { reportError } from 'utils/error'
import { IFont, LoadingState } from 'stores/IFont'

export type ICustomFont = Font

const FONT_LOADING_TIMEOUT = 30000 // 30s

export class CustomFont implements IFont {
  name: IFont['name']
  family: IFont['family']
  sourceUrl: string
  variants: IFont['variants']
  workspaceId: number
  loadingState: IFont['loadingState'] = 'idle'
  loadingPromise?: IFont['loadingPromise']

  constructor(font: ICustomFont, workspaceId: number) {
    makeAutoObservable(this)

    this.name = font.name
    this.family = font.font_family
    this.variants = [Object.values(FONT_WEIGHTS).find((value) => value === font.font_subfamily) || 'Regular']
    this.sourceUrl = font.source_url
    this.workspaceId = workspaceId
  }

  get weights() {
    return this.variants.map((variant) => {
      const variantByName = Object.keys(FONT_WEIGHTS).find(
        (key) => FONT_WEIGHTS[key as unknown as FontWeightType] === variant,
      )
      return (variantByName ? parseInt(variantByName) : 400) as FontWeightType
    })
  }

  get weight() {
    return this.weights[0]
  }

  get italicWeights() {
    return this.weights
  }

  get url() {
    return this.sourceUrl
  }

  setLoadingState = (loadingState: LoadingState) => {
    this.loadingState = loadingState
  }

  load = async () => {
    if (this.loadingState === 'loaded' || this.loadingState === 'loading') {
      return this.loadingPromise
    }

    this.setLoadingState('loading')
    this.loadingPromise = new FontFaceObserver(this.name, { weight: this.weights[0].toString() })
      .load(null, FONT_LOADING_TIMEOUT)
      .then(() => {
        this.setLoadingState('loaded')
      })
      .catch((e) => {
        reportError(e)
        this.setLoadingState('idle')
      })

    return this.loadingPromise
  }
}
